module.exports = __webpack_public_path__ + "img/top-left-corner.31a64629.svg";